@if (notifications().length > 0) {
<section class="translationNotifications" aria-label="Translation status updates" aria-live="polite">
    @for (notification of notifications(); track notification.id) {
    <article class="translationNotification" [class.translationNotification--started]="notification.state === 'started'"
        [class.translationNotification--updated]="notification.state === 'updated'"
        [class.translationNotification--completed]="notification.state === 'completed'"
        [class.translationNotification--error]="notification.state === 'error'" [attr.role]="getRole(notification)">
        <span class="translationNotification__marker" aria-hidden="true"></span>

        <div class="translationNotification__body">
            <p class="translationNotification__title">{{ notification.title }}</p>
            <p class="translationNotification__message">{{ notification.message }}</p>
            <time class="translationNotification__time" [dateTime]="notification.updatedAt.toISOString()">
                {{ notification.updatedAt | date:'shortTime' }}
            </time>
        </div>

        <button class="translationNotification__dismiss" type="button" aria-label="Dismiss translation status update"
            (click)="dismiss(notification.id)">
            x
        </button>
    </article>
    }
</section>
}
